import { isStringNullOrWhiteSpace } from 'owa-localize';
import { isFeatureEnabled } from 'owa-feature-flags';

import type Message from 'owa-service/lib/contract/Message';

const MEETINGPOLL_MESSAGE_IDENTIFIER = 'findtime/vote?getrequesturl=';

export default function hasMeetingPoll(message: Message): boolean {
    if (!isFeatureEnabled('cal-mf-meetingPollCard') || !message) {
        return false;
    }

    let messageBody = null;
    if (message.UniqueBody) {
        messageBody = message.UniqueBody.Value;
    } else if (message.NormalizedBody) {
        messageBody = message.NormalizedBody.Value;
    }

    return (
        !isStringNullOrWhiteSpace(messageBody) &&
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2531 (25,9): Object is possibly 'null'.
        // @ts-expect-error
        messageBody.indexOf(MEETINGPOLL_MESSAGE_IDENTIFIER) > -1
    );
}
